import axios from 'axios';
import { setupInterceptors } from './authInterceptor';

const api3005 = axios.create({
    baseURL: process.env.REACT_APP_API_3005_URL,
});

setupInterceptors(api3005);

export default api3005;
